import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneInput from "../../../OneInput/OneInput"
import OneSelect from "../../../OneSelect/OneSelect"
import { useContext, useEffect, useState } from "react"
import { CondominiosContext } from "../../../../Providers/CondominiosContext/CondominiosContext"
import { OrdemServicoContext } from '../../../../Providers/OrdemServicoContext/OrdemServicoContext'
import { tiposOrdemServico } from '../../../../Utils/optionsSelects'
import ComboBox from '../../../ComboBox/ComboBox'
import { showNotify } from "../../../../Utils/Utils"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"

const newSx = {
    input: {
        height: { xs: '30px', lg: '21px', xl: '30px' },
        fontSize: { lg: '10px', xl: '15px' }
    },
    label: {
        fontSize: { lg: '13px', xl: '15px' }
    }
}

export const lineSx = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px'
}

export const formGroupSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // width: '100%',
    gap: '3px'
}

export const formGroupInput = {
    flexGrow: 1
}

const PesquisarOrdemServico = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const { filtros, setFiltros, buscarOrdensServico } = useContext(OrdemServicoContext)
    const { condominios, activeCond } = useContext(CondominiosContext)
    const [optionsTecnicos, setOptionsTecnicos] = useState([{ id: 0, nome: 'Selecionar' }])

    const [formData] = useState({})

    const optionsCondominios = condominios.map((condominio) => {
        return { nome: `${condominio.id_central}-${condominio.nome} `, id_central: condominio.id_central }
    })
    optionsCondominios.unshift({ nome: 'Todos', id_central: 'all' })

    useEffect(() => {
        addRoute('buscarListagens#ordemServico#tecnicos', (msg) => {
            const { status, message } = msg.data

            if (status === 'error' || !status) {
                showNotify('danger', message)
                return
            }

            let tecnicos = msg.data?.listagens?.tecnico

            tecnicos.unshift({ id: 0, nome: 'Selecionar' })

            setOptionsTecnicos(tecnicos)
        })

        sendWs('buscarListagens#ordemServico#tecnicos', {
            listagens: {
                tecnico: ["id", "nome", "nivel"]
            }
        })
    }, [])

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFiltros({ ...filtros, [event.target.name]: event.target.checked })
            } else {
                setFiltros({ ...filtros, [event.target.name]: event.target.value })
            }
        }
    }

    return (
        <Grid sx={{ gap: '5px', display: 'flex', flexDirection: 'column' }}>
            <Grid sx={lineSx}>
                <Grid sx={formGroupSx} xs={4}>
                    <Typography sx={newSx.label}>Pesquisar: </Typography>
                    <Grid sx={formGroupInput}>
                        <OneInput
                            newSx={newSx.input}
                            placeholder={"Alguma palavra dentro da OS"}
                            defaultValue={filtros?.pesquisa || ""}
                            name="pesquisa"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>

                <Grid sx={formGroupSx} xs>
                    <Typography sx={newSx.label}>Cond./Empresa: </Typography>
                    <Grid sx={formGroupInput}>
                        <ComboBox
                            newSx={newSx.input}
                            options={optionsCondominios}
                            value={filtros?.id_central || activeCond.id_central || optionsCondominios[0].id_central}
                            label="nome"
                            valor="id_central"
                            name="id_central"
                            onChange={handleChange}
                            todos
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid sx={lineSx}>
                <Grid sx={formGroupSx} xs>
                    <Typography sx={newSx.label}>Dt inicial: </Typography>
                    <Grid sx={formGroupInput}>
                        <OneInput
                            newSx={newSx.input}
                            defaultValue={filtros?.data_inicial}
                            type="date"
                            name="data_inicial"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>

                <Grid sx={formGroupSx} xs>
                    <Typography sx={newSx.label}>Dt final:</Typography>
                    <Grid sx={formGroupInput}>
                        <OneInput
                            newSx={newSx.input}
                            defaultValue={filtros?.data_final}
                            type="date"
                            name="data_final"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>

                <Grid sx={formGroupSx} xs={3}>
                    <Typography sx={newSx.label}>Status:</Typography>
                    <Grid sx={formGroupInput}>
                        <OneSelect
                            newSx={newSx.input}
                            options={[{ id: 0, descricao: 'Todos' }, { id: 1, descricao: 'Abertos' }, { id: 2, descricao: 'Em andamento' }, { id: 3, descricao: 'Fechados' }, { id: 4, descricao: 'Cancelados' }]}
                            defaultValue={filtros?.status || 0}
                            name="status"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>

                <Grid sx={formGroupSx} xs={2.3}>
                    <Typography sx={newSx.label}>Tipo: </Typography>
                    <Grid sx={formGroupInput}>
                        <OneSelect
                            newSx={newSx.input}
                            options={[{ id: 0, descricao: 'Todos' }, ...tiposOrdemServico.getAll()]}
                            defaultValue={filtros?.tipo || 0}
                            name="tipo"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid sx={lineSx}>
                <Grid sx={formGroupSx} xs>
                    <Typography sx={{ ...newSx.label, width: '11%' }} >Técnico: </Typography>
                    <Grid sx={formGroupInput}>
                        <ComboBox
                            newSx={newSx.input}
                            options={optionsTecnicos}
                            defaultValue={optionsTecnicos[0].id}
                            name="tecnico"
                            label="nome"
                            valor="id"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid sx={{ display: 'flex', justifyContent: 'end' }} xs>
                    <Button
                        variant="contained"
                        color="one_primary"
                        sx={{
                            height: { lg: '20px', xl: '30px' },
                            fontSize: { lg: '11px', xl: '14px' }
                        }}
                        onClick={() => buscarOrdensServico(formData)}
                    >Filtrar</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PesquisarOrdemServico
